import { create } from 'zustand'
import api from '../apis/api';
import { useGroupStore } from './Groups';

export const useOrgStore = create((set, get) => ({
    org: "",
    site: "",
    asset: null,
    gs_asset: null,
    groups:[],
    users:[],
    deviceRoles: [],
    selectedType: null,
    active_tab: "overview",
    errorMessage: "",
    set_active_tab: (active_tab) => set({ active_tab }),
    set_groups: (groups) => set({ groups }),
    set_users: (users) => set({ users }),
    setSelectedType: (selectedType) => set({ selectedType }),
    set_org_site: async (org, site) => {
        set({ org, site });
    },
    get_asset: async(id, siteId=null) => {
        let params = {id: id}
        if(siteId){
            params.siteId = siteId;
        }
        api.get('/assets/info', {params: params}).then(r => {
            set({asset: r.data, errorMessage: ""})
        }).catch(err => {
            set({asset: "error",  errorMessage: err.response.data.detail,})
        })
    },
    clear_asset: async() => {
        set({asset: null})
    },
    get_gs_asset: async(id, siteId=null) => {
        const params = {
            id: id,
            siteId: siteId
        }
        return api.get('/gs_assets/info', { params: params }).then(r => {
            set({gs_asset: r.data, errorMessage: ""})
        }).catch(err => {
            set({gs_asset: "error",  errorMessage: err.response.data.detail,})
        })
    },
    clear_gs_asset: async() => {
        set({gs_asset: null})
    },
    setDeviceRoles: (deviceRoles) => {
        set({ deviceRoles })
    },
}))